import image from '/public/assets/images/legal-texts/cross.svg';
import {useTranslation} from "react-i18next";
import parse from 'html-react-parser';
import {LegalTextsState} from "../../../context/LegalTextsContext.tsx";
import {useEffect, useState} from "react";
import {LinearProgress} from "@mui/material";

const LegalModal = ({heading, type}: {heading: string, type: 'privacy_terms'|'payment_terms'}) => {

    const {t} = useTranslation();
    const {
        isPaymentTermsOpen,
        isPrivacyPolicyOpen,
        setIsPaymentTermsOpen,
        setIsPrivacyPolicyOpen,
        termsAndConditions
    } = LegalTextsState();

    const [text, setText] = useState<string|null>(null);

    useEffect(() => {
        if (!termsAndConditions) {
            return;
        }

        setText(termsAndConditions[type]);
    }, [termsAndConditions]);

    const closeModal = () => {
        setIsPaymentTermsOpen(false);
        setIsPrivacyPolicyOpen(false);
    }

    return (
        <>
            <div className={
                `screen-aligner ${isPaymentTermsOpen || isPrivacyPolicyOpen ? 'popup-opened-background' : ''}`
            }>
                <div className={`popup-container show`}>
                    <div className="popup-header">
                        <p className="popup-heading">{t(heading)}</p>
                        <div className="close-icon-container" onClick={closeModal}>
                            <img className="close-icon" src={image} alt="Information close icon"/>
                        </div>
                    </div>
                    <div className="popup-text-container">{text ? parse(text) : <LinearProgress />}</div>

                    <div className="popup-btn-container">
                        <button className="submit-btn popup-btn" onClick={closeModal}>
                            {t('close')}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LegalModal;
